export default __webpack_public_path__ + "b3148ee803ced83e0a12f9d54366daeb.png";